import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, DrawerStepper } from '@mercai/clever'
import { LogisticPreferencesDrawerProps } from './logistic-preferences-drawer.type'
import { LogisticPreferencesForm } from './components'
import { ProfileProps } from '@/types'

export const LogisticPreferencesDrawer = ({
  isOpen,
  onHandleOpen,
  onSubmit,
  isLoading = false,
  values,
}: LogisticPreferencesDrawerProps) => {
  const { t } = useTranslation('screenProfileShow')

  const [internalValues, setInternalValues] = useState<Partial<ProfileProps>>({
    selectedDeliveryPeriods: values?.selectedDeliveryPeriods,
    selectedDeliveryDays: values?.selectedDeliveryDays,
  })

  useEffect(() => {
    setInternalValues({
      selectedDeliveryPeriods: values?.selectedDeliveryPeriods,
      selectedDeliveryDays: values?.selectedDeliveryDays,
    })

    return () => {
      setInternalValues({})
    }
  }, [values])

  return (
    <DrawerStepper
      translations={{
        optional: '',
      }}
      isOpen={isOpen}
      onHandleOpen={onHandleOpen}
      title={t('logisticPreferencesDrawerTitle')}
      initialStep="root"
      steps={{
        root: {
          isOptional: true,
          backNavigate: 'root',
          component: (
            <LogisticPreferencesForm
              values={internalValues}
              onValuesChange={setInternalValues}
            />
          ),
          footer: () => (
            <>
              <Button variant="secondary" onClick={onHandleOpen}>
                {t('backLabel')}
              </Button>
              <Button
                onClick={() => onSubmit?.(internalValues)}
                isActive={!isLoading}
                disabled={isLoading}
              >
                {t('confirmLabel')}
              </Button>
            </>
          ),
        },
      }}
    />
  )
}
